/*
 * @Author: ZHANGJIAN
 * @Date: 2021-10-20 16:36:15
 * @LastEditTime: 2022-01-21 13:30:39
 * @LastEditors: ZHANGJIAN
 * @Description:
 */
var vueLogin = new Vue({
  el: "#vue-login",
  mixins: [mixin],
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data: {
    form: {
      uct: "0",
      srt: "2",
      pp: "",
      pwd: "",
      verify: "",
      local: CONFIG.local,
    },
    vfImg: `/gf/web/comm/verifyCode.do?paramName=LOGIN&t=${new Date().getTime()}`,
    isViewPwd: false,
    users: Store.state.message,
  },
  created() {
    let _self = this;
    //处理Enter健 登录
    $(document).keyup(function (event) {
      if (event.keyCode == 13) {
        _self.handleLoginClick();
      }
    });
  },
  mounted() {
    this.init();
  },

  methods: {
    //初始化
    init() {
      if (!!this.userInfo) {
        location.href = "/index.html";
      }
    },
    //刷新验证码
    handleVerifyChange() {
      this.vfImg = `/gf/web/comm/verifyCode.do?paramName=LOGIN&t=${new Date().getTime()}`;
    },
    //点击登录
    handleLoginClick() {
      let _self = this;
      this.$refs.form.validate().then((valid) => {
        if (!valid) {
          return;
        }

        Axios.post("/gf/web/pp/login.do", _self.form, {
          headers: { requestBody: false },
        }).then(function (res) {
          if (res.code === "0") {
            //登录成功
            _self.callbackUrl();
            // location.href = "/index.html";
          } else {
            //失败了就刷新一下验证码
            _self.handleVerifyChange();
            _self.$message.error(res.msg || Message.error);
          }
        });
      });
    },
    //清除账号
    handleClearClick() {
      this.form.pp = "";
    },
    //可见密码点击
    handleEyeClick() {
      this.isViewPwd = !this.isViewPwd;
    },
    //facebook登錄
    fbLogin() {
      window.location.href = `/gf/web/oauth/facebook/login.do?returnUrl=${encodeURIComponent(
        window.location.href
      )}`;
    },
    //google登錄
    ggLogin() {
      window.location.href = `/gf/web/oauth/google/login.do?returnUrl=${encodeURIComponent(
        window.location.href
      )} `;
    },
  },
});
